import { useState } from 'react';
import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// API Endpoints
import { LABELS } from '@/lib/routes/apiEndpoints';

export const formatLabelList = (list) =>
    list?.length > 0 ? list.map((el) => ({ label: el.label, value: el.label, id: el.label })) : [];

const useLabels = ({ activeSPID, options = {}, params = undefined } = {}) => {
    const [requestParams, setRequestParams] = useState(params);

    const apiEndpoint = injectEndpointUrlParams(`${LABELS}/all`, { SPID: activeSPID });
    const {
        data: labels,
        mutate: mutateLabels,
        error: errorLabels,
        isLoading
    } = useSWR(
        [apiEndpoint, requestParams ? JSON.stringify(requestParams) : undefined],
        ([url]) => get(url, requestParams).then((res) => res.data?.labels),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        labels,
        mutateLabels,
        errorLabels,
        isLoading,
        requestParams,
        setRequestParams
    };
};

export default useLabels;
